export default "﻿<div>\n    <div data-dojo-attach-point=\"agendaView\" data-dojo-type=\"moreCore/UI/AgendaView/AgendaView\">\n    </div>\n</div>"